"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllPages = exports.getNextPageToken = exports.shouldRefreshDependencyOnMount = exports.shouldRefreshDependency = exports.resolveDependency = exports.callPaginatedDependency = exports.callDependency = exports.pollDependency = exports.dependenciesHaveData = void 0;
var connectorStore_1 = require("../connectorStore");
var error_1 = require("../error");
var networkUtils = require("../network");
var response_1 = require("../response");
var retry_1 = require("../retry");
var variant_1 = require("../variant");
var queryFunctions_1 = require("./queryFunctions");
/**
 * Checks that all variants passed have data
 * Used for optimistic rendering in case an error only came from Polling (usually due to network blip
 */
function dependenciesHaveData() {
    var variants = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        variants[_i] = arguments[_i];
    }
    return variants.every(function (v) { return v.result && v.result.data; });
}
exports.dependenciesHaveData = dependenciesHaveData;
var falsePredicate = function () { return false; };
function pollDependency(dependency, store, setPollingInterval, pollUntil) {
    var _this = this;
    if (pollUntil === void 0) { pollUntil = falsePredicate; }
    if (!document.hidden) {
        var dependencyKey_1 = dependency.dependencyKey;
        var _a = connectorStore_1.normalizedGet(store, dependencyKey_1), _b = _a.variant, status_1 = _b.status, result = _b.result, _c = _a.metadata.lastFetchTime, lastFetchTime = _c === void 0 ? 0 : _c;
        var dataIsStale = Date.now() - queryFunctions_1.getPollingInterval(dependency.options) >= lastFetchTime;
        if (status_1 === variant_1.Status.Success && dataIsStale && !pollUntil(result)) {
            connectorStore_1.setPolling(store, dependencyKey_1);
            // NOTE: we don't retry on polling because if we get throttled during polling, we
            // definitely don't want to keep hitting the API, and retry is only useful in that situation currently
            resolveDependency(dependency, store, setPollingInterval).catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
                var error;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, error_1.normalizeError(e)];
                        case 1:
                            error = _a.sent();
                            connectorStore_1.setError(store, dependencyKey_1, error);
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    }
}
exports.pollDependency = pollDependency;
function callDependency(dependency, store, setPollingInterval) {
    var _this = this;
    var dependencyKey = dependency.dependencyKey;
    var status = connectorStore_1.normalizedGet(store, dependencyKey).variant.status;
    if (status !== variant_1.Status.Pending &&
        status !== variant_1.Status.Refreshing &&
        status !== variant_1.Status.Polling) {
        if (!networkUtils.isOnline()) {
            connectorStore_1.setError(store, dependencyKey, error_1.getGenericOfflineError());
        }
        else if (status === variant_1.Status.Success) {
            connectorStore_1.setRefreshing(store, dependencyKey);
        }
        else {
            connectorStore_1.setPending(store, dependencyKey);
        }
        retry_1.retry(function () { return resolveDependency(dependency, store, setPollingInterval); }, dependency.options.retry).catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, error_1.normalizeError(e)];
                    case 1:
                        error = _a.sent();
                        connectorStore_1.setError(store, dependencyKey, error);
                        return [2 /*return*/];
                }
            });
        }); });
    }
}
exports.callDependency = callDependency;
function callPaginatedDependency(dependency, store, mergePages, page) {
    var _this = this;
    var dependencyKey = dependency.dependencyKey;
    var status = connectorStore_1.normalizedGet(store, dependencyKey).variant.status;
    if (status !== variant_1.Status.Pending) {
        if (!networkUtils.isOnline()) {
            connectorStore_1.setError(store, dependencyKey, error_1.getGenericOfflineError());
        }
        else if (status === variant_1.Status.Success && page) {
            connectorStore_1.setFetchingNextPage(store, dependencyKey);
        }
        else {
            connectorStore_1.setPending(store, dependencyKey);
        }
        retry_1.retry(function () { return resolveDependencyPage(dependency, store, mergePages, page); }, dependency.options.retry).catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, error_1.normalizeError(e)];
                    case 1:
                        error = _a.sent();
                        connectorStore_1.setError(store, dependencyKey, error);
                        return [2 /*return*/];
                }
            });
        }); });
    }
}
exports.callPaginatedDependency = callPaginatedDependency;
function resolveDependencyPage(dependency, store, mergePages, page) {
    return __awaiter(this, void 0, void 0, function () {
        var dependencyKey, dependencyRef, currentState, args, result, serializedResponse, existingResponse, needMerge, mergedResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dependencyKey = dependency.dependencyKey, dependencyRef = dependency.dependencyRef, currentState = dependency.currentState, args = dependency.options.args;
                    return [4 /*yield*/, dependencyRef(__assign(__assign({}, args), { page: page }))];
                case 1:
                    result = (_a.sent());
                    serializedResponse = response_1.serializeResponse(result);
                    existingResponse = currentState.variant
                        .result;
                    needMerge = !!existingResponse && !!page;
                    mergedResponse = needMerge
                        ? mergePages(existingResponse, serializedResponse)
                        : serializedResponse;
                    connectorStore_1.setSuccess(store, dependencyKey, mergedResponse);
                    return [2 /*return*/];
            }
        });
    });
}
function resolveDependency(dependency, store, setPollingInterval) {
    return __awaiter(this, void 0, void 0, function () {
        var dependencyKey, dependencyRef, _a, args, shouldFetchAllPages, variant, pageLoadedWithDispatch, response, pollingInterval, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dependencyKey = dependency.dependencyKey, dependencyRef = dependency.dependencyRef, _a = dependency.options, args = _a.args, shouldFetchAllPages = _a.fetchAllPages, variant = dependency.currentState.variant;
                    pageLoadedWithDispatch = function (dependencyKey, response) {
                        connectorStore_1.updateResponse(store, dependencyKey, response);
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 9, , 10]);
                    response = void 0;
                    if (!shouldFetchAllPages) return [3 /*break*/, 6];
                    if (!dependenciesHaveData(variant)) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchAllPages(function (page) {
                            return dependencyRef(__assign(__assign({}, args), { page: page }));
                        })];
                case 2:
                    response = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, fetchAllPages(function (page) { return dependencyRef(__assign(__assign({}, args), { page: page })); }, dependencyKey, pageLoadedWithDispatch)];
                case 4:
                    response = _b.sent();
                    _b.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, dependencyRef(args)];
                case 7:
                    response = _b.sent();
                    _b.label = 8;
                case 8:
                    pollingInterval = queryFunctions_1.getPollingInterval(dependency.options);
                    pollingInterval && setPollingInterval(pollingInterval);
                    connectorStore_1.setSuccess(store, dependencyKey, response_1.serializeResponse(response));
                    return [3 /*break*/, 10];
                case 9:
                    e_1 = _b.sent();
                    // cancel polling anytime an apiCall fails, it'll start if/when it succeeds again
                    setPollingInterval(null);
                    throw e_1;
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.resolveDependency = resolveDependency;
function shouldRefreshDependency(dependency) {
    var cachingOptions = dependency.options.caching;
    if (!cachingOptions) {
        return true;
    }
    var lastFetchTime = dependency.currentState.metadata.lastFetchTime;
    switch (cachingOptions.type) {
        case "basic":
            return cachingOptions.refreshOnMount;
        case "polling":
            if (cachingOptions.refreshOnMount ||
                cachingOptions.refreshOnMount === undefined) {
                return true;
            }
            return Date.now() - cachingOptions.pollingInterval >= lastFetchTime;
        case "ttl":
            return Date.now() - cachingOptions.refreshIfOlderThan >= lastFetchTime;
        default:
            var compileGuard = cachingOptions;
            throw new TypeError("Unknown type: " + compileGuard);
    }
}
exports.shouldRefreshDependency = shouldRefreshDependency;
function shouldRefreshDependencyOnMount(dependency) {
    // if we don't have previous state, or we're in an error/unknown state we should refresh
    if (!dependency.currentState ||
        dependency.currentState.variant.status === variant_1.Status.Error ||
        dependency.currentState.variant.status === variant_1.Status.Unknown) {
        return true;
    }
    // if we're not sitting in a success state, bail
    if (dependency.currentState.variant.status !== variant_1.Status.Success) {
        return false;
    }
    return shouldRefreshDependency(dependency);
}
exports.shouldRefreshDependencyOnMount = shouldRefreshDependencyOnMount;
function isHeadersObject(headers) {
    // unit tests fail the instanceof check, so use get being a function as a fallback
    return headers instanceof Headers || typeof headers.get === "function";
}
var nextPageHeaderKey = "opc-next-page";
exports.getNextPageToken = function (response) {
    if (response && response.headers) {
        if (isHeadersObject(response.headers)) {
            return response.headers.get(nextPageHeaderKey);
        }
        return response.headers[nextPageHeaderKey];
    }
    return undefined;
};
/**
 * uses next page header to get all pages of data until there are no more
 */
function fetchAllPages(apiMethod, dependencyKey, apiPageLoaded) {
    return __awaiter(this, void 0, void 0, function () {
        var result, nextPage, allData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    allData = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, apiMethod(nextPage)];
                case 2:
                    result = _a.sent();
                    if (!response_1.isResponseWithData(result)) {
                        return [2 /*return*/, result];
                    }
                    allData = allData.concat(result.data);
                    nextPage = exports.getNextPageToken(result.response);
                    if (nextPage && apiPageLoaded && dependencyKey) {
                        apiPageLoaded(dependencyKey, response_1.serializeResponse({
                            data: allData,
                            response: result.response,
                        }));
                    }
                    _a.label = 3;
                case 3:
                    if (nextPage) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/, { data: allData, response: result.response }];
            }
        });
    });
}
exports.fetchAllPages = fetchAllPages;
//# sourceMappingURL=dependency.js.map